import clsx from 'clsx';
import React from 'react';
import Icon from '../../atoms/Icon/Icon';
import { isIconName } from '../../icons/types';
import type { IconBubbleProps } from './types';
import useIconBubble from './useIconBubble';

/**
 * IconBubble — v2 molecule.
 *
 * Contenedor circular (o cuadrado con `variant="square"`) con un {@link Icon}
 * centrado. `size` define el contenedor; el icono interior se escala en
 * proporción automáticamente.
 */
function IconBubble({ background = 'default', className, color, gradient, name, size = 'md', variant = 'default' }: IconBubbleProps): JSX.Element {
  const { bubbleSize, colorState, iconSizeState } = useIconBubble({ color, size, variant });
  const resolvedName = name && isIconName(name) ? name : null;

  return (
    <div
      className={clsx('icon-bubble', `icon-bubble--size-${bubbleSize}`, `icon-bubble--background-${background}`, `icon-bubble--variant-${variant}`, className)}
      style={gradient ? { background: gradient } : undefined}
    >
      {resolvedName && <Icon color={colorState} name={resolvedName} size={iconSizeState} />}
    </div>
  );
}

export default IconBubble;
